import {createStore, combineReducers, compose, applyMiddleware} from "redux";
import {loadState} from "./state";
import thunk from "redux-thunk";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {users_module} from "./users";
import {company_module} from "./company";
import {establishment_module} from "./establishment";
import {employees_module} from "./employees";
import {supplier_module} from "./supplier";
import {visitant_module} from "./visitant";
import {jobs_module} from "./jobs";
import {visits_module} from "./visits";
import {base_module} from './base';
import {help_module} from './help';
import {email_module} from './email_zones';
import {zone_module} from './zones';
import {departures_module} from './departures';
import {visits_and_departures_module} from './monitoringDeparturesAndVisits.js';
import {email_setting_module} from "./email_setting.js";
import {income_module} from "./income.js";
import {reason_decline_module} from "./reason_decline.js";
import {bank_module} from "./banks.js";
import {reason_dismissal_module} from "./reason_dismissal.js";
import {form_module} from "./forms.js";
import {section_module} from "./sections.js";
import {group_module} from "./groups";
import {field_types_module} from "./field_types";
import {fields_module} from "./fields";
import {fields_options_module} from "./fields_options.js";
import { reason_movement_module } from "./reason_movement.js";
import {type_novelty_module} from "./type_novelty";
import {operator_module} from "./operator";
import {novelty_module} from "./novelty";
import {supervisor_module} from "./supervisor";
import {turn_module} from "./turn";
import {note_module} from "./note";
import {type_custody_module} from "./type_custody";
import {custodian_module} from "./custodian";
import {custody_module} from "./custody";
import {bonus_module} from "./bonus";
import {type_shipping_request_module} from "./type_shipping_request";
import {shipping_request_module} from "./shipping_request";
import {reason_shipping_request_module} from "./reason_shipping_request";
import {type_maintenance_module} from "./type_maintenance";
import {reason_maintenance_module} from "./reason_maintenance";
import {maintenance_module} from "./maintenance";
import {maintenance_survey_module} from "./maintenance_survey";
import {maintenance_survey_option_module} from "./maintenance_survey_option";
import {maintenance_survey_results_module} from "./maintenance_survey_results";
import {type_day_module} from "./type_day";
import {reason_purchases_module} from "./reason_purchases";
import {product_module} from "./products";
import {purchase_module} from "./purchases";
import {detail_purchase_module} from "./detail_purchases";
import {vehicle_module} from "./vehicles";
import {employee_vehicle_module} from "./employee_vehicle";
import {service_module} from "./services";
import {vehicle_maintenance_module} from "./vehicle_maintenance";
import {service_vehicle_maintenance_module} from "./service_vehicle_maintenance";
import {maintenance_supplier_module} from "./maintenance_supplier";
import {category_maintenance_module} from "./categories_maintenances";
import {product_type_module} from "./product_types";
import {log_mileage_vehicle_module} from "./log_mileage_vehicle";
import {item_vehicle_maintenance_module} from "./item_vehicle_maintenance";
import {novelty_vehicle_maintenance_module} from "./novelty_maintenance_vehicle";
import {vacancies_notification_module} from "./vacancies_notification";
import {vacancies_module} from "./vacancies";
import {qr_configuration_module} from "./qr_configuration";


const rootReducer = combineReducers({
    users_module: users_module,
    email_module: email_module,
    company_module: company_module,
    establishment_module: establishment_module,
    employees_module: employees_module,
    supplier_module: supplier_module,
    visitant_module: visitant_module,
    jobs_module: jobs_module,
    visits_module: visits_module,
    base_module: base_module,
    help_module: help_module,
    zone_module: zone_module,
    departures_module: departures_module,
    visits_and_departures_module: visits_and_departures_module,
    email_setting_module: email_setting_module,
    income_module: income_module,
    reason_decline_module: reason_decline_module,
    bank_module: bank_module,
    reason_dismissal_module: reason_dismissal_module,
    form_module: form_module,
    section_module: section_module,
    group_module: group_module,
    field_types_module: field_types_module,
    fields_module: fields_module,
    fields_options_module: fields_options_module,
    reason_movement_module: reason_movement_module,
    type_novelty_module: type_novelty_module,
    operator_module: operator_module,
    novelty_module: novelty_module,
    supervisor_module: supervisor_module,
    turn_module: turn_module,
    note_module: note_module,
    type_custody_module: type_custody_module,
    custodian_module: custodian_module,
    custody_module: custody_module,
    bonus_module: bonus_module,
    type_shipping_request_module: type_shipping_request_module,
    reason_shipping_request_module: reason_shipping_request_module,
    shipping_request_module: shipping_request_module,
    category_maintenance_module: category_maintenance_module,
    type_maintenance_module: type_maintenance_module,
    reason_maintenance_module: reason_maintenance_module,
    maintenance_module: maintenance_module,
    maintenance_survey_module: maintenance_survey_module,
    maintenance_survey_option_module: maintenance_survey_option_module,
    maintenance_survey_results_module: maintenance_survey_results_module,
    type_day_module: type_day_module,
    reason_purchases_module: reason_purchases_module,
    product_type_module: product_type_module,
    product_module: product_module,
    purchase_module: purchase_module,
    detail_purchase_module: detail_purchase_module,
    vehicle_module: vehicle_module,
    employee_vehicle_module: employee_vehicle_module,
    service_module: service_module,
    vehicle_maintenance_module: vehicle_maintenance_module,
    service_vehicle_maintenance_module: service_vehicle_maintenance_module,
    maintenance_supplier_module: maintenance_supplier_module,
    log_mileage_vehicle_module: log_mileage_vehicle_module,
    item_vehicle_maintenance_module: item_vehicle_maintenance_module,
    novelty_vehicle_maintenance_module: novelty_vehicle_maintenance_module,
    vacancies_notification_module: vacancies_notification_module,
    vacancies_module: vacancies_module,
    qr_configuration_module: qr_configuration_module,
});

const persistConfig = {
    key: "root",
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const generateStore = () => {
    const initialData = loadState();

    const store = createStore(
        persistedReducer,
        initialData,
        composeEnhancers(applyMiddleware(thunk))
    );

    const persistor = persistStore(store, ["auth"]);

    return {store, persistor};
};
